<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { DSDialog, DSDialogContent, DSDialogHeader, DSDialogTitle, DSDialogDescription, DSDialogFooter, DSButton } from '@ds'

const props = defineProps<{
  modal: ModalClass<any>
  title: string
  description?: string
  label: string
}>()

const emit = defineEmits<{
  cancel: []
  confirm: []
}>()

const isOpen = computed(() => props.modal.isOpened)

const handleCancel = () => {
  emit('cancel')
  props.modal.close()
}

const handleConfirm = () => {
  emit('confirm')
  props.modal.close()
}
</script>

<template>
  <DSDialog
    :open="isOpen"
    @update:open="handleCancel"
  >
    <DSDialogContent>
      <DSDialogHeader>
        <DSDialogTitle>{{ title }}</DSDialogTitle>
        <DSDialogDescription v-if="description">
          {{ description }}
        </DSDialogDescription>
      </DSDialogHeader>
      <DSDialogFooter>
        <DSButton
          type="button"
          variant="secondary"
          @click="handleCancel"
        >
          Cancel
        </DSButton>
        <DSButton
          type="button"
          variant="destructive"
          @click="handleConfirm"
        >
          {{ label }}
        </DSButton>
      </DSDialogFooter>
    </DSDialogContent>
  </DSDialog>
</template>
